/**
 * API Configuration
 * 
 * This file automatically detects the current environment and provides the appropriate API URL.
 * - In development: Uses localhost
 * - In production: Uses environment variable or relative path through reverse proxy
 */

// Base API URL configuration
export const API_URL = (() => {
  // 1. Primeiro, tentar usar a variável de ambiente (definida no build)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // 2. Se não houver variável de ambiente, detectar automaticamente
  if (typeof window === 'undefined') return 'http://localhost:7006/api';
  
  const hostname = window.location.hostname;
  const protocol = window.location.protocol; // http: ou https:
  
  // Em desenvolvimento local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:7006/api';
  }
  
  // Em produção, usa o mesmo protocolo e hostname (através do reverse proxy)
  return `${protocol}//${hostname}/api`;
})();

// Export other API-related configurations if needed
export const API_TIMEOUT = 30000; // 30 seconds
